var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.784 2.723a.606.606 0 0 1 .857 0L14.49 7.57a.606.606 0 0 1 0 .857L9.64 13.277a.606.606 0 0 1-.857-.857l3.814-3.814H1.94a.606.606 0 0 1 0-1.212h10.658L8.784 3.58a.606.606 0 0 1 0-.857Z",
    fill: "#fff"
  })));
};

export default SvgArrowRight;